module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"volume":"Volume","seasonality":"Seasonality"},"fr":{"volume":"Volume","seasonality":"Saisonnalité"},"de":{"volume":"Volumen","seasonality":"Saisonalität"}}')
  delete Component.options._Ctor
}
